const SENSITIVE_KEY_PATTERN =
  /(password|token|authorization|secret|api[_-]?key|access[_-]?token|refresh[_-]?token|email|jwt)/i;

const EMAIL_PATTERN = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;

function redactString(value) {
  if (typeof value !== "string") {
    return value;
  }

  if (EMAIL_PATTERN.test(value)) {
    return value.replace(EMAIL_PATTERN, "[redacted-email]");
  }

  if (value.length > 500) {
    return `${value.slice(0, 500)}…`;
  }

  return value;
}

export function sanitizeTelemetryPayload(payload, depth = 0) {
  if (depth > 4) {
    return "[truncated]";
  }

  if (payload == null || typeof payload !== "object") {
    return redactString(payload);
  }

  if (Array.isArray(payload)) {
    return payload.slice(0, 20).map((item) => sanitizeTelemetryPayload(item, depth + 1));
  }

  const sanitized = {};

  for (const [key, value] of Object.entries(payload)) {
    if (SENSITIVE_KEY_PATTERN.test(key)) {
      sanitized[key] = "[redacted]";
      continue;
    }

    sanitized[key] = sanitizeTelemetryPayload(value, depth + 1);
  }

  return sanitized;
}
